// extracted by mini-css-extract-plugin
export default {"input":"vqO8kT6N","large":"Y4EhgP8u","error":"nyqUiBAq","input-wrapper":"j6IBdb7f","right-element":"NtosjVxY"};